import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TabLink from './TabLink';
import ChatStyles from '../Chat.module.css';
import { useSelector } from 'react-redux';

const TabLinks = ({ link1Label, link1Click, link1Active, setShowAddGroupMoal, link1Notification, link2Label, link2Click, link2Active, link2Notification }) => {
  const { t } = useTranslation();
  const [notificationCount, setNotificationCount] = React.useState();

  const userLogin = useSelector(state => state.userLogin);

  useEffect(() => {
    setNotificationCount(link2Notification);
  }, [link2Notification]);

  return (
    <div className={ChatStyles.chatLists_tabs}>
      <div className={ChatStyles.tabContainer}>
        <TabLink onClick={link1Click} active={link1Active} label={link1Label} notification={link1Notification} />
        <TabLink onClick={link2Click} active={link2Active} label={link2Label} notification={notificationCount} />
      </div>
      {!userLogin?.userInfo?.data?.user?.modules?.adminOnlyChat | (userLogin?.userInfo?.data?.user?.role === 'clientAdmin') ? (
        <div>
          <button className={ChatStyles.button_with_popup} onClick={() => setShowAddGroupMoal(true)}>
            <svg>
              <use xlinkHref={`/assets/sprite.svg#icon-group-chat`} />
              {/* <use xlinkHref={`/assets/sprite.svg#icon-chat`} /> */}
            </svg>
            <p>{t('screens.chat.newGroupChat')}</p>
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default TabLinks;
